import React, { useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { User } from "firebase/auth";
import { AuthContext } from "../context/AuthContext";
import {initRedditPixel} from "../lib/helpers/redditPixelHelper.ts";
import {identifyTikTokPixelUser} from "../lib/helpers/tiktokPixelHelper.ts";
import {initFacebookPixel} from "../lib/helpers/facebookPixelHelper.ts";
import {identifyOpenAiPixelUser} from "../lib/helpers/openAiPixelHelper.ts";
import {setSentryUser} from "../lib/sentry.ts";
import {identifyBrazeUser} from "../lib/helpers/brazeHelper.ts";

const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user !== null) {
       initRedditPixel(user.email);
       identifyTikTokPixelUser(user.email);
       initFacebookPixel('1907004970242420', user.email);
       void identifyOpenAiPixelUser(user.uid, user.email);
       setSentryUser(user.uid, user.email ?? undefined);
       identifyBrazeUser(user.uid, user.email ?? undefined);
      }
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
